import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { createRequestOption } from '../../model/request-util';
import { SERVER_API_URL } from '../../../environment.constants';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';
import { ParamContext } from '../../service/param.context';
import { MethodDetails } from '../model/method-details';
import { MethodSearchRequest } from '../model/method-search-request.model';

@Injectable()
export class MethodService {

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getMethods(): Observable<MethodDetails[]> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<MethodDetails[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    queryMethods(query: string): Observable<HttpResponse<MethodDetails[]>> {
        return this.http.get<MethodDetails[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/methods/search?query=` + query, { observe: 'response' });
    }

    searchMethods(search: MethodSearchRequest, req: any): Observable<HttpResponse<MethodDetails[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods/search`;
        return this.http.post<MethodDetails[]>(url, search, {
            params,
            observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getMethodId(methodId: string): Observable<MethodDetails> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods/${methodId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<MethodDetails>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    update(method: MethodDetails): Observable<HttpResponse<MethodDetails>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods/${method.id}?programUUID=${this.paramContext.programUUID}`;
        return this.http.put<MethodDetails>(url, method, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    create(method: MethodDetails): Observable<HttpResponse<{ id: string }>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods?programUUID=${this.paramContext.programUUID}`;
        return this.http.post<{ id: string }>(url, method, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    delete(methodId: string): Observable<HttpResponse<any>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/methods/${methodId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.delete<any>(url, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }
}
